import pause from './pause.png';
import play from './play.png';
import playFocused from './playFocused.png';
import reload from './reload.png';
import reloadFocused from './reloadFocused.png';

export const VOD_Icons = {
  play,
  playFocused,
  reload,
  reloadFocused,
  pause,
};
